export const environment = {
  // apiBaseUrl: 'https://mimas.tn.gov.in/xen0.2/0.2',
  vtsBaseUrl: 'https://portal.miningvts.in',
  //apiBaseUrl: 'https://www.mimas.tn.gov.in/0.2',
  apiBaseUrl: 'https://devmtsv1.xenovex.com/0.2',
  signalrUrl: 'https://mtssignalr.xenovex.com/notifyHub',
  authLessBaseUrl: 'https://devmtsv1.xenovex.com',
  karuvoolamBaseUrl: "https://103.59.16.41",
  weighBridgeUrl: 'http://localhost',
  StoppageIntervalSecs: 300,
  tokenEndPoint: '/api/token',
  xAuthToken: "AUTHM!NES2o25GPSTRACk!NGKEEYC0DE",
  production: false,
  environment: 'Local',
  showEnvironment: true,
  webAppVersion: '2.0.3',
};
